import VideoCard from '@/components/base/VideoCard';
import { videos } from '@/mocks/data';

export default function FeaturedVideos() {
  const featured = videos.filter((v) => v.featured).slice(0, 8);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100/60">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-2">
            精选推荐
          </h2>
          <p className="text-sm text-foreground-500">编辑精选 · 不容错过的优质内容</p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-5" data-product-shop>
          {featured.map((video) => (
            <VideoCard
              key={video.id}
              id={video.id}
              title={video.title}
              slug={video.slug}
              thumbnail={video.thumbnail}
              duration={video.duration}
              categoryName={video.categoryName}
              views={video.views}
              date={video.date}
              rating={video.rating}
            />
          ))}
        </div>
      </div>
    </section>
  );
}